import React,{useEffect,useState} from 'react';
import {hasOfflineUpdate,applyOfflineUpdate} from '../services/offlineShell';
import {Button} from './ui';
/** Updates are discoverable even before sign-in or account approval. */
export default function AppUpdateNotice(){
 const [waiting,setWaiting]=useState(hasOfflineUpdate);
 useEffect(()=>{const change=()=>setWaiting(hasOfflineUpdate());window.addEventListener('sonata-offline-update',change);change();return()=>window.removeEventListener('sonata-offline-update',change);},[]);
 if(!waiting)return null;
 return <aside role="status" aria-label="App update" className="flex shrink-0 flex-wrap items-center justify-between gap-3 border-b bg-white px-4 py-3"><p className="text-sm">An app update is ready. Finish any open form or route before restarting.</p><Button size="sm" onClick={applyOfflineUpdate}>Update & restart</Button></aside>;
}
